<template>
  <v-switch
    v-bind="$attrs"
    v-on="$listeners"
    :false-value="0"
    :true-value="1"
    :input-value="value"
  ></v-switch>
</template>

<script>
  export default {
    name: 'SwitchButton',
    props: {
      value: {},
    },
  }
</script>

<style scoped>

</style>
